export default {
    DEFAULT: "DEFAULT",
    SINGLE: "SINGLE",
    WAVE_LEFT: "WAVE_LEFT",
    WAVE_RIGHT: "WAVE_RIGHT",
    WAVE_BOTH: "WAVE_BOTH"
};